// 使用 webpack 的 require.context 加载图标
const req = require.context('../../assets/icons/svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys()

const re = /\.\/(.*)\.svg/

// 从导入的文件路径中提取图标名称
const icons = requireAll(req).map(i => {
  return i.match(re)[1]
})

console.log('Available icons:', icons)

export default icons
